/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
/**
 * Camera intrinsics, the phone-photo analog of the on-device
 * intrinsics.json — 35mm-equivalent focal length + dimensions pin down the
 * field of view, real signal for scale reasoning.
 * @export
 * @interface ImageMetadata
 */
export interface ImageMetadata {
    /**
     * 
     */
    widthPx?: number | null;
    /**
     * 
     */
    heightPx?: number | null;
    /**
     * 
     */
    cameraMake?: string | null;
    /**
     * 
     */
    cameraModel?: string | null;
    /**
     * 
     */
    focalLengthMm?: number | null;
    /**
     * 
     */
    focalLength35mmEquivMm?: number | null;
    /**
     * 
     */
    capturedAt?: Date | null;
    /**
     * 
     */
    capturedAtOffset?: string | null;
    /**
     * 
     */
    latitude?: number | null;
    /**
     * 
     */
    longitude?: number | null;
}

/**
 * Check if a given object implements the ImageMetadata interface.
 */
export function instanceOfImageMetadata(value: object): value is ImageMetadata {
    return true;
}

export function ImageMetadataFromJSON(json: any): ImageMetadata {
    return ImageMetadataFromJSONTyped(json, false);
}

export function ImageMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImageMetadata {
    if (json == null) {
        return json;
    }
    return {
        
        'widthPx': json['width_px'] === undefined ? undefined : json['width_px'] === null ? null : json['width_px'],
        'heightPx': json['height_px'] === undefined ? undefined : json['height_px'] === null ? null : json['height_px'],
        'cameraMake': json['camera_make'] === undefined ? undefined : json['camera_make'] === null ? null : json['camera_make'],
        'cameraModel': json['camera_model'] === undefined ? undefined : json['camera_model'] === null ? null : json['camera_model'],
        'focalLengthMm': json['focal_length_mm'] === undefined ? undefined : json['focal_length_mm'] === null ? null : json['focal_length_mm'],
        'focalLength35mmEquivMm': json['focal_length_35mm_equiv_mm'] === undefined ? undefined : json['focal_length_35mm_equiv_mm'] === null ? null : json['focal_length_35mm_equiv_mm'],
        'capturedAt': json['captured_at'] === undefined ? undefined : json['captured_at'] === null ? null : (parseDateTime(json['captured_at'])),
        'capturedAtOffset': json['captured_at_offset'] === undefined ? undefined : json['captured_at_offset'] === null ? null : json['captured_at_offset'],
        'latitude': json['latitude'] === undefined ? undefined : json['latitude'] === null ? null : json['latitude'],
        'longitude': json['longitude'] === undefined ? undefined : json['longitude'] === null ? null : json['longitude'],
    };
}

export function ImageMetadataToJSON(json: any): ImageMetadata {
    return ImageMetadataToJSONTyped(json, false);
}

export function ImageMetadataToJSONTyped(value?: ImageMetadata | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'width_px': value['widthPx'],
        'height_px': value['heightPx'],
        'camera_make': value['cameraMake'],
        'camera_model': value['cameraModel'],
        'focal_length_mm': value['focalLengthMm'],
        'focal_length_35mm_equiv_mm': value['focalLength35mmEquivMm'],
        'captured_at': value['capturedAt'] == null ? value['capturedAt'] : serializeDateTime(value['capturedAt']),
        'captured_at_offset': value['capturedAtOffset'],
        'latitude': value['latitude'],
        'longitude': value['longitude'],
    };
}

